import { Dictionary } from '@classes/dictionary/dictionary';
import { BaseClass } from '@classes/base-class';
import { Client } from '@classes/client';
import { Site } from '@classes/site';
import { BaseRepository } from '@interfaces/base-repository';

export class DictionaryValue extends BaseClass implements BaseRepository {
  name: string;
  dictionary: Dictionary;
  client?: Client;
  site?: Site;
  sortOrder: number;
  isChecked?: boolean;
  selected?: boolean;

  constructor()
  constructor(
    name: string,
    dictionary: Dictionary,
    client: Client,
    site: Site,
    sortOrder: number
  )
  constructor(
    name?: string,
    dictionary?: Dictionary,
    client?: Client,
    site?: Site,
    sortOrder?: number
  ) {
    super();

    this.name = this.trim(name);
    this.client = client;
    this.site = site;
    this.dictionary = dictionary;
    this.sortOrder = sortOrder;
  }

  static fromObject(object: DictionaryValue): DictionaryValue {
    return Object.assign(new DictionaryValue(), {
      ...object,
      client: object.client ? Client.fromObject(object.client) : null,
      site: object.site ? Site.fromObject(object.site) : null,
      dictionary: object.dictionary ? Dictionary.fromObject(object.dictionary) : null,
    });
  }

  get display(): string {
    return `${this.name}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.name], value);
  }

}
